export const stCarriers = {
  tcat: '黑貓',
  ktj: '大榮',
  hct: '新竹',
  ty: '通盈',
  sf: '顺丰',
  711: '7-11',
  cvs: '超商',
  fami: '全家超商',
  tccs: '黑猫超商',
  bld: '便利带',
}

export function stCarrierToName (stCarrier) {
  return stCarriers[stCarrier]
}

export function includeTax (item) {
  const m = String(item.jyoShpMethod)
  return m !== '71' && m !== '81' && m !== '91'
}

export function getParameterByName (name, url) {
  if (!url) url = window.location.href
  name = name.replace(/[[]]/g, '\\$&')
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  const results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export const xlsx = {
  getCharCol (n) {
    let s = ''
    let m = 0
    while (n >= 0) {
      m = n % 26 + 1
      s = String.fromCharCode(m + 64) + s
      n = (n - m) / 26
    }
    return s
  },
  s2ab (s) {
    if (typeof ArrayBuffer !== 'undefined') {
      const buf = new ArrayBuffer(s.length)
      const view = new Uint8Array(buf)
      for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
      return buf
    } else {
      const buf = new Array(s.length)
      for (let i = 0; i !== s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF
      return buf
    }
  },
  coverXlsxBlob (json, saveParams) {
    const XLSX = window.XLSX
    var tmpdata = json[0]
    json.unshift({})
    var keyMap = [] // 获取keys
    for (var k in tmpdata) {
      if (k === 's') {
        continue
      }
      keyMap.push(k)
      json[0][k] = k
    }
    tmpdata = []// 用来保存转换好的json

    function getValue (v, k) {
      if (/^empty\d*$/.test(k)) {
        return ''
      }
      return v[k]
    }

    json.map((v, i) => keyMap.map((k, j) => Object.assign({}, {
      v: getValue(v, k),
      position: (j > 25 ? this.getCharCol(j) : String.fromCharCode(65 + j)) + (i + 1),
      s: v.s
    }))).reduce((prev, next) => prev.concat(next)).forEach((v, i) => {
      if (v.v != null) {
        tmpdata[v.position] = {
          v: v.v,
          t: typeof v.v === 'number' ? 'n' : 's',
          s: v.s,
        }
      }
    })
    var outputPos = Object.keys(tmpdata) // 设置区域,比如表格从A1到D10
    var tmpWB = {
      SheetNames: ['mySheet'], // 保存的表标题
      Sheets: {
        'mySheet': Object.assign({},
          tmpdata, // 内容
          {
            '!ref': outputPos[0] + ':' + outputPos[outputPos.length - 1] // 设置填充区域
          })
      }
    }
    var tmpDown
    if (saveParams && saveParams.bookType) {
      // window.XLSX 不支持 bookType
      tmpDown = new Blob([this.s2ab(XLSX.write(tmpWB,
        { bookType: saveParams.bookType, type: 'binary', }// 这里的数据是用来定义导出的格式类型
      ))], {
        type: ''
      })
    } else {
      tmpDown = new Blob([this.s2ab(window.XLSX.write(tmpWB,
        { bookType: 'xlsx', type: 'binary' }// 这里的数据是用来定义导出的格式类型
      ))], {
        type: ''
      })
    }
    return tmpDown
  },
  saveAs (obj, fileName) { // 当然可以自定义简单的下载文件实现方式
    var tmpa = document.createElement('a')
    tmpa.download = fileName || '下载'
    tmpa.href = URL.createObjectURL(obj) // 绑定a标签
    tmpa.click() // 模拟点击实现下载
    setTimeout(function () { // 延时释放
      URL.revokeObjectURL(obj) // 用URL.revokeObjectURL()来释放这个object URL
    }, 100)
  },

  excelToJson (file) {
    if (file.name.indexOf('.csv') > -1) {
      return new Promise((resolve) => {
        const reader = new FileReader()
        reader.onload = function (e) {
          let data = e.target.result
          resolve(data.split('\n').map(item => item.split(',')))
        }
        reader.readAsBinaryString(file)
      })
    }

    const XLSX = window.XLSX
    const rABS = typeof FileReader !== 'undefined' && FileReader.prototype && FileReader.prototype.readAsBinaryString
    const reader = new FileReader()
    const useworker = typeof Worker !== 'undefined'

    function fixdata (data) {
      let o = ''
      let l = 0
      const w = 10240
      for (; l < data.byteLength / w; ++l) { o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w))) }
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(o.length)))
      return o
    }

    function toJson (workbook) {
      if (useworker && workbook.SSF) XLSX.SSF.load_table(workbook.SSF)
      const result = {}
      workbook.SheetNames.forEach(function (sheetName) {
        const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {raw: false, header: 1})
        if (roa.length > 0) result[sheetName] = roa
      })
      return result
    }

    return new Promise((resolve, reject) => {
      reader.onload = function (e) {
        let data = e.target.result
        let wb, arr
        const readtype = { type: rABS ? 'binary' : 'base64' }
        if (!rABS) {
          arr = fixdata(data)
          data = btoa(arr)
        }
        try {
          wb = XLSX.read(data, readtype)

          wb.SheetNames.forEach(sheet => {
            const json = toJson(wb)[sheet]
            if (json && json.length) {
              resolve(json)
            }
          })
        } catch (e) { reject(e) }
      }
      if (rABS) reader.readAsBinaryString(file)
      else reader.readAsArrayBuffer(file)
    })
  },
}

export function readFile (fileRes) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsArrayBuffer(fileRes)
    reader.onload = () => {
      resolve(reader.result)
    }
  })
}

export function copyText (text) {
  const el = document.createElement('textarea')
  el.addEventListener('focusin', e => e.stopPropagation())
  el.value = text
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}



// WEBPACK FOOTER //
// ./src/utils/index.js